import request from '@/api/request.js'

// 订单列表
export const getSaleOrderListPage = (params) => {
  return request({
    url: '/analyse/adm/baseOrderData/getListPage',
    method: 'get',
    params
  })
}

// 更改归属
export const updateBaseOrderSaleId = (data) => {
  return request({
    url: '/analyse/adm/baseOrderData/updateBaseOrderSaleId',
    method: 'post',
    data
  })
}

// 更改归属操作记录
export const getLogListPage = (params) => {
  return request({
    url: '/analyse/analyse/adm/baseHandleLog/getListPage',
    method: 'get',
    params
  })
}
